import React, { useEffect } from "react";
import { useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import { LogoutUser } from "../../Apis/loginApi";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink, useLocation } from "react-router-dom";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { withTranslation } from "react-i18next";
import Loader from "../Loader/loader";
import "./sidebar.css";
import isGHMC from "../../Common/helper/helpar";
import { jwtDecode } from "jwt-decode";
import { useHeaderStore } from "../Header/headerStore";

const Sidebar = ({ t, isSidebarOpen, loginPermission }) => {
  const { isSidebarMenuOpen, sidebarMenuOpen, sidebarMenuClose } = useHeaderStore();

  const location = useLocation();
  const dashboardsPageURLs = ["/sat-dashboard", "/scv-dashboard", "/gvp-dashboard", "/primary-dashboard", "/teritary-dashboard"];
  const userManagementPageURLs = ["/roles", "/users", "/active-users"];
  const mobileUsersPageURLs = ["/scv-drivers", "/primary-deployment-charge-master", "/secondary-deployment-incharges", "/transferstation-incharge", "/traffic-marshal", "/loading-equipment-driver-details", "/route-supervisor"];
  const organizationStructurePageURLs = ["/organization-zone", "/organization-circle", "/organization-ward", "/shifts", "/transferStation"];
  const assetsMastersPageURLs = ["/vehicle-type", "/vehicle-capacity", "/owner-type", "/vehicles", "/loading-equipment", "/Containers"];
  const attendanceMastersPageURLs = ["/operations", "/designations", "/employee", "/driver-ts-map"];
  const IEMastersPageURLs = ["/ts-feedback-category", "/hygiene-observation", "/independent-engineer"];
  const mastersPageURLs = ["/routes", "/deployment-locations", ...assetsMastersPageURLs, ...organizationStructurePageURLs, ...attendanceMastersPageURLs, ...IEMastersPageURLs];
  const SATsReportsPageURLs = ["/day_detail_report", "/trip_tssctp"];
  const SCVReportsPageURLs = ["/scv_report_circle", "/scv-deployed-trips"];
  const TTRReportsPageURLs = ["/trips-tonnage-reports", "/hook_loader_report", "/container_report"];
  const GVPReportsPageURLs = ["/gvp-report", "/gvp-report-date", "/gvp-multiple-clearence", "/gvp-clearance-report"];
  const transactionModuleReportsPageURLs = ["/primary-deployment-transaction-report", "/secondary-deployment-transaction-report", "/deployed-hookloader-report", "/secondary-collection-transaction", "/deployed-container-transaction", "/all-transferstation-transaction", "/container-hookloader-transaction", "/traffic-marshal-transaction-report", "/tertiary-deployment-details", "/tertiary-trip-details"];
  const geofenceReportsPageURLs = ["/geofence-summary", "/geofence-vehicle-reports", "/geofence-vehicle-summary-reports"];
  const loadingEquipmentReportsPageURLs = ["/loading_equipment_deployment-summary-report", "/loading_equipment_certification-report", "/loading_equipment_clearance-report", "/contractor-wise-report"];
  const trafficMarshalReportsPageURLs = ["/unloading-wait-time", "/vehicle-total-weightment", "/live-reports", "/summary-reports"];
  const tertiaryReportsPageURLs = ["/deployment-report-teritary", "/trip-report-teritary", "/summary-report-teritary"];
  const attendanceReportsPageURLs = ["/attendance-summary-report", "/attendance-daily-report", "/month-wise-attendance-summary-report"];
  const grievanceReportsPageURLs = ["/grievance-detailed-report"];
  const routesPageURLs = ["/collection-points", "/route-master"];
  const reportsPageURLS = [...SATsReportsPageURLs, ...SCVReportsPageURLs, ...TTRReportsPageURLs, ...GVPReportsPageURLs, ...transactionModuleReportsPageURLs, ...geofenceReportsPageURLs, ...loadingEquipmentReportsPageURLs, trafficMarshalReportsPageURLs, ...trafficMarshalReportsPageURLs, ...tertiaryReportsPageURLs, ...attendanceReportsPageURLs, ...grievanceReportsPageURLs, "/clearing-disinfection-bin-capsule-report"];

  const [prodclassName, setProdClassName] = useState('');
  const classes = useStyles();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [openMasters, setOpenMasters] = React.useState(mastersPageURLs.includes(location.pathname) ? true : false);
  const [openOrganizationStructure, setOpenOrganizationStructure] = React.useState(organizationStructurePageURLs.includes(location.pathname) ? true : false);
  const [openAssetsMasters, setOpenAssetsMasters] = React.useState(assetsMastersPageURLs.includes(location.pathname) ? true : false);
  const [openReports, setOpenReports] = React.useState(reportsPageURLS.includes(location.pathname) ? true : false);
  const [openUserManagement, setOpenUserManagement] = React.useState(userManagementPageURLs.includes(location.pathname) ? true : false);
  const [openRoutesPages, setOpenRoutesPages] = React.useState(routesPageURLs.includes(location.pathname) ? true : false);
  const [openTransactionModuleReports, setOpenTransactionModuleReports] = React.useState(transactionModuleReportsPageURLs.includes(location.pathname) ? true : false);
  const [openDashboards, setOpenDashboards] = React.useState(dashboardsPageURLs.includes(location.pathname) ? true : false);
  const [openMobileUsers, setOpenMobileUsers] = React.useState(mobileUsersPageURLs.includes(location.pathname) ? true : false);
  const [isLoading, setLoading] = React.useState(false);

  const isProd = isGHMC();

  useEffect(() => {
    if (isGHMC()) {
      setProdClassName('ghmc-true');
    } else {
      setProdClassName('ghmc-false');
    }
  }, []);

  // Permission check functions (unchanged)
  const hasDashboardPermission = () => userPermissionCategory?.includes("Dashboard");
  const hasPrimaryDashboardPermission = () => userPermission?.includes("Transfer Station");
  const hasTeritaryDashboardPermission = () => userPermission?.includes("Secondary Deployment");
  const hasGVPDashboardPermission = () => userPermission?.includes("Primary Collection");
  const hasSCVDashboardPermission = () => userPermission?.includes("SCVs Dashboard");
  const hasPrimaryDeploymentDashboardPermission = () => userPermission?.includes("Primary Deployment");
  const hasOrganizationPermission = () => userPermissionCategory?.includes("Organization");
  const hasZonePermission = () => userPermission?.includes("Zone");
  const hasCirclePermission = () => userPermission?.includes("Ward");
  const hasWardPermission = () => userPermission?.includes("Ward");
  const hasVehicleTypePermission = () => userPermission?.includes("Vehicle Type");
  const hasVehicleCapacityPermission = () => userPermission?.includes("Vehicle Capacity");
  const hasOwnerTypePermission = () => userPermission?.includes("Owner Type");
  const hasVehiclePermission = () => userPermission?.includes("Vehicles");
  const hasLoadingEquipmnetPermission = () => userPermission?.includes("Loading Equipments");
  const hasShiftsPermission = () => userPermission?.includes("Shifts");
  const hasCollectionPointsPermission = () => userPermission?.includes("Route Points");
    const hasCollectionMasterPermission = () => userPermission?.includes("Route Master");
     const hasCollectionPathSummaryPermission = () => userPermission?.includes("Route Path Summary");
  const hasRoutesPermission = () => userPermission?.includes("Routes");
  const hasTransferStationPermission = () => userPermission?.includes("TransferStation");
  const hasContainersPermission = () => userPermission?.includes("Containers");
  const hasDeploymentLocationsPermission = () => userPermission?.includes("Deployment Locations");
  const hasPrimaryDeploymentPermission = () => userPermission?.includes("SFA InCharges");
  const hasSecondaryDeploymentChargesPermission = () => userPermission?.includes("Deployment Incharges");
  const hasTransferstationInchargesPermission = () => userPermission?.includes("TransferStation InCharge");
  const hasTrafficMarshalUserPermission = () => userPermission?.includes("Traffic Marshal,");
  const hasLoadingEquipmentDriverDetailsPermission = () => userPermission?.includes("Loading Equipment Driver Details");
  const hasRouteTrackingPermission = () => userPermission?.includes("Route Tracking");
  const hasLoadingEquipmentReportsPermission = () => userPermissionCategory?.includes("Loading Equipment Reports");
  const hasSATsDetailedReportsPermission = () => userPermission?.includes("SAT Detailed Report");
  const hasSATsTripsPermission = () => userPermission?.includes("SAT Trip to TS/SCTP");
  const hasLoadingEquipmentCertificationPermission = () => userPermission?.includes("Loading Equipment Certification");
  const hasLoadingEquipmentClearancePermission = () => userPermission?.includes("Loading Equipment Clearance Report");
  const hasLoadingEquipmentPermission = () => userPermission?.includes("Loading Equipment Report");
  const hasContractorWiseLoadingEquipmentPermission = () => userPermission?.includes("Contractor Wise Loading Equipment");
  const hasSCVReportsPermission = () => userPermissionCategory?.includes("SCV Reports");
  const hasSCVReportCirclePermission = () => userPermission?.includes("Reported SCVs at Circle");
  const hasSCVDeployedTripsPermission = () => userPermission?.includes("SCVs Deployed Trips to TS/SCTP");
  const hasSCVOverallTripsPermission = () => userPermission?.includes("SCVs Overall Trips to TS/SCTP");
  const hasTTRReportsPermission = () => userPermissionCategory?.includes("TTR Reports");
  const hasTransactionReports = () => userPermissionCategory?.includes("Transaction Reports");
  const hasGWPReportsPermission = () => userPermission?.includes("GWP Reports");
  const hasTrafficMarshalPermission = () => userPermission?.includes("Traffic Marshal Transaction Report");
  const hasTeritaryDeploymentPermission = () => userPermission?.includes("Secondary Deployment");
  const hasTeritaryReportPermission = () => userPermissionCategory?.includes("Teritary Reports");
  const hasTeritaryTripPermission = () => userPermission?.includes("Secondary Trip");
  const hasPrimaryDeploymentTransactionPermission = () => userPermission?.includes("Primary Deployment Transaction Report");
  const hasSecondaryDeploymentTransactionPermission = () => userPermission?.includes("Deployment Transaction Report");
  const hasRoutePointTransactionPermission = () => userPermission?.includes("Route Point Transaction Report");
  const hasSecondaryCollectionTransactionReportPermission = () => userPermission?.includes("Primary Collection Transaction");
  const hasDeployedContainerTransactionReportPermission = () => userPermission?.includes("Deployed Container Transaction");
  const hasAllTransfertationTransactionReportsPermission = () => userPermission?.includes("Transfer Station Transaction");
  const hasHookLoaderDeploymentTransactionPermission = () => {
    return userPermission?.includes("Deployed Hookloader Transaction Report");
  };
  const hasContainerHookLoaderTransactionReportsPermission = () => userPermission?.includes("Container HookLoader Transaction");
  const hasRolesPermission = () => userPermission?.includes("Roles");
  const hasUserCreationsPermission = () => userPermission?.includes("Users");
  const hasMasterCreatePermission = () => userPermissionCategory?.includes("User Management");
  const hasActiveUserPermission = () => userPermission?.includes("Active Users");
  const hasContainerPermission = () => userPermission?.includes("Container TTR Report");
  const hasMasterAssetsPermission = () => userPermissionCategory?.includes("Assets");
  const hasMasterRoutesPermission = () => userPermissionCategory?.includes("Routes");
  const hasMobileUsersPermission = () => userPermissionCategory?.includes("Mobile Users");
  const hasDriverAppPermission = () => userPermission?.includes("Drivers");
  const hasMobileAPKsPermission = () => userPermission?.includes("Mobile APK's");




  const hasPrimaryCollectionReport = () => userPermission?.includes("Primary Collection Report");
  const hasSecondaryCollectionReport = () => userPermission?.includes("Secondary Collection Report");
  const hasCommercialCollectionReport = () => userPermission?.includes("Commercial Collection Report");
  const hasHorticultureCollectionReport = () => userPermission?.includes("Horticulture Waste Collection & Transportation Report");
  const hasDrainSlitCollectionReport = () => userPermission?.includes("Drain Slit C&T Waste Collection & Transportation Report");
  const hasAnimalCarCollectionReport = () => userPermission?.includes("Animal Car C&T Waste Collection & Transportation Report");
  const hasVehicleWashingReport = () => userPermission?.includes("Vehicle Washing Report");
  const hasDHWCTCollectionReport = () => userPermission?.includes("DHW C&T Waste Collection & Transportation Report");
  const hasBinClearingCollectionReport = () => userPermission?.includes("Bin Clearing And Disinfection Waste Collection & Transportation Report");
  const hasCollectionOfSolidWasteReport = () => userPermission?.includes("Collection of solid waste from Market Areas Report");
  const hasInstallationOfSignageBoardsReport = () => userPermission?.includes("Installation of Signage Boards Report");
  const hasTripsAndTonnageReport = () => userPermission?.includes("Trips and Tonnage Report");
  const hasTimelyStreetSweepingReport = () => userPermission?.includes("Timely Street sweeping B/A");
  const hasRoutePointTransactionReport = () => userPermission?.includes("Mobile APK's");

  const userPermission = localStorage.getItem("loginPermissions");
  const userPermissionCategory = localStorage.getItem("permissionCategoryNames");
  let storedPermissionsData = JSON.parse(sessionStorage.getItem('permissionsData')) || [];
  let storedPermissions = storedPermissionsData.map((item) => item.permissionId);

  // Modified toggle handlers to close other dropdowns
  const handleToggleDashboards = () => {
    setOpenDashboards(!openDashboards);
    setOpenMasters(false);
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenReports(false);
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleMasters = () => {
    setOpenMasters(!openMasters);
    setOpenDashboards(false);
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenReports(false);
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleOrganizationStructure = () => {
    setOpenOrganizationStructure(!openOrganizationStructure);
    setOpenDashboards(false);
    setOpenMasters(true); // Keep Masters open as Organization is nested
    setOpenAssetsMasters(false);
    setOpenReports(false);
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleAssetsMasters = () => {
    setOpenAssetsMasters(!openAssetsMasters);
    setOpenDashboards(false);
    setOpenMasters(true); // Keep Masters open as Assets is nested
    setOpenOrganizationStructure(false);
    setOpenReports(false);
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleReports = () => {
    setOpenReports(!openReports);
    setOpenDashboards(false);
    setOpenMasters(false);
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleUserManagement = () => {
    setOpenUserManagement(!openUserManagement);
    setOpenDashboards(false);
    setOpenMasters(false);
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenReports(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleRoutesPages = () => {
    setOpenRoutesPages(!openRoutesPages);
    setOpenDashboards(false);
    setOpenMasters(true); // Keep Masters open as Routes is nested
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenReports(false);
    setOpenUserManagement(false);
    setOpenTransactionModuleReports(false);
    setOpenMobileUsers(false);
  };

  const handleToggleTransactionModuleReports = () => {
    setOpenTransactionModuleReports(!openTransactionModuleReports);
    setOpenDashboards(false);
    setOpenMasters(false);
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenReports(true); // Keep Reports open as Transaction Reports is nested
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenMobileUsers(false);
  };

  const handleToggleMobileUsers = () => {
    setOpenMobileUsers(!openMobileUsers);
    setOpenDashboards(false);
    setOpenMasters(false);
    setOpenOrganizationStructure(false);
    setOpenAssetsMasters(false);
    setOpenReports(false);
    setOpenUserManagement(false);
    setOpenRoutesPages(false);
    setOpenTransactionModuleReports(false);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('token');
    let decodedToken = null;
    try {
      if (token) {
        decodedToken = jwtDecode(token);
        console.log('Decoded Token:', decodedToken);
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      toast.error("There was an issue with your session. Please log in again.");
      return;
    }

    const payload = {
      token,
      userId: decodedToken?.UserId || null,
      sessionId: decodedToken?.SessionId || null,
      userType: decodedToken?.UserType || null,
    };
    try {
      const response = await LogoutUser(payload);
      if (response.statusCode === 404) {
        toast.error("Your session has already expired or is invalid.");
      } else {
        toast.success("You have been successfully logged out.");
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('userType');
        localStorage.removeItem("selectedItems");
        setIsLoggedIn(false);
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error("An error occurred during logout. Please try again.");
    }
  };

  const sidebarClassName = isSidebarOpen
    ? "app-sidebar sidebar-shadow closed-sidebar"
    : "sidebar-mobile-open .app-sidebar";

  const callPermissionFunction = (permissionId) => {
    localStorage.setItem('permissionId', permissionId);
    console.log(permissionId)
  };

  const handleZoneClick = () => callPermissionFunction(1);
  const handleCircleClick = () => callPermissionFunction(3);
  const handleVehicleTypeClick = () => callPermissionFunction(4);
  const handleVehicleCapacityClick = () => callPermissionFunction(5);
  const handleOwnerTypeClick = () => callPermissionFunction(6);
  const handleVehiclesClick = () => callPermissionFunction(7);
  const handleLoadingEuipmentClick = () => callPermissionFunction(8);
  const handleShiftsClick = () => callPermissionFunction(9);
  const handleCollectionPointsClick = () => callPermissionFunction(10);
  const handleRouteMasterClick = () => { };
  const handleRouteClick = () => callPermissionFunction(11);
  const handleTransferStationClick = () => callPermissionFunction(12);
  const handleContainersClick = () => callPermissionFunction(13);
  const handleRolesClick = () => callPermissionFunction(23);
  const handleUsersClick = () => callPermissionFunction(24);
  const handleScvDriverClick = () => callPermissionFunction(25);
  const handleSecondaryDeploymentInchargeClick = () => callPermissionFunction(27);
  const handleTransferStationInchargeClick = () => callPermissionFunction(28);
  const handleTrafficMarshaltClick = () => callPermissionFunction(50);

  return (
    <div className={sidebarClassName}>
      <div className={`navigation ${isSidebarMenuOpen ? "open" : ""} ${prodclassName}`} style={{ overflow: "hidden" }} >
        <div className="navigation-header">
          <span>Navigation</span>
          <a href="#" onClick={() => sidebarMenuClose()}>
            <i className={`ti-close ${isProd ? "icon-blue" : "icon-red"}`}></i>
          </a>
        </div>
        <div
          className="navigation-menu-body"
          style={{
            overflowY: openMasters || openOrganizationStructure || openAssetsMasters || openReports ? "scroll" : "scroll",
            overflowX: "hidden"
          }}
        >
          <div className="header-logo">
            <a>
              <img className="logo" src="/assets/media/image/logo_small.png" alt="logo"
                style={{ width: "70px", height: "auto" }}
              />
            </a>
          </div>
          <List
            className={classes.appMenu}
            disablePadding
            style={{ color: "black", marginBottom: "30px", marginTop: "10px" }}
          >
            {hasDashboardPermission("Dashboard") && (
              <ListItem
                button
                onClick={handleToggleDashboards}
                className={`${isProd ? (openDashboards ? "bg-ghmc" : "bg-transparent") : (openDashboards ? "bg-swm" : "bg-transparent")}`}
                component={NavLink}
              >
                <ListItemIcon className={classes.menuItemIcon}>
                  <i className={`fa fa-tachometer-alt ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText primary={t("dashboard")} />
                {openDashboards ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            )}
            <Collapse in={openDashboards} timeout="auto" unmountOnExit>
              {hasDashboardPermission("DashBoard") && hasPrimaryDeploymentDashboardPermission("Primary Deployment") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/scv-dashboard" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/scv-dashboard"
                  style={{ display: "flex" }}
                >
                  <ListItemText inset primary={t("Primary Deployment")} style={{ paddingLeft: "25px" }} />
                  {location.pathname === "/scv-dashboard" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasDashboardPermission("DashBoard") && hasGVPDashboardPermission("Primary Collection") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/gvp-dashboard" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/gvp-dashboard"
                  style={{ display: "flex" }}
                >
                  <ListItemText inset primary={t("Primary Collection")} style={{ paddingLeft: "25px" }} />
                  {location.pathname === "/gvp-dashboard" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasDashboardPermission("DashBoard") && hasPrimaryDashboardPermission("Transfer Station") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  component={NavLink}
                  to="/primary-dashboard"
                  style={{ display: "flex", borderRadius: "0px" }}
                  className={`${classes.menuItem} ${location.pathname === "/primary-dashboard" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                >
                  <ListItemText inset primary={t("Transfer Station")} style={{ paddingLeft: "25px" }} />
                  {location.pathname === "/primary-dashboard" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasDashboardPermission("DashBoard") && hasTeritaryDashboardPermission("Secondary Deployment") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/teritary-dashboard" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/teritary-dashboard"
                  style={{ display: "flex" }}
                >
                  <ListItemText inset primary={t("Secondary Deployment")} style={{ paddingLeft: "25px" }} />
                  {location.pathname === "/teritary-dashboard" && <ActiveIndicator />}
                </ListItem>
              )}
            </Collapse>
            {hasOrganizationPermission("Organization") ||
              hasMasterAssetsPermission("Assets") ||
              hasCollectionPointsPermission("Collection Points") ||
              hasRoutesPermission("Routes") ||
              hasDeploymentLocationsPermission("Deployment Locations") ? (
              <ListItem
                button
                onClick={handleToggleMasters}
                className={`
                  ${classes.menuItem} 
                  ${location.pathname.startsWith("/city-master") ||
                    location.pathname.startsWith("/companies") ||
                    location.pathname.startsWith("/organization") ||
                    location.pathname.startsWith("/shifts") ||
                    location.pathname.startsWith("/collectionpoint-details") ||
                    location.pathname.startsWith("/route-master") ||
                    location.pathname.startsWith("/transfer-station-master") ||
                    location.pathname.startsWith("/container-master") ||
                    location.pathname.startsWith("/deployment-location-master") ||
                    location.pathname.startsWith("/deployment-charge-master") ||
                    location.pathname.startsWith("/driver-creation") ||
                    location.pathname.startsWith("/owner-type") ||
                    location.pathname.startsWith("/vehicle-type") ||
                    location.pathname.startsWith("/vehicle") ||
                    location.pathname.startsWith("/collection-points") ||
                    location.pathname.startsWith("/route-master") ||
                    location.pathname === "/routeTracking"
                    ? `${isProd ? "active-ghmc" : "active-swmnew"} icon-white`
                    : ""
                  } 
                  ${isProd ? (openMasters ? "bg-ghmc" : "bg-transparent") : (openMasters ? "bg-swm" : "bg-transparent")}`}
                activeClassName="active-link"
                style={{ left: "1.5px" }}
              >
                <ListItemIcon className={classes.menuItemIcon}>
                  <i className={`fa-solid fa-gear ${isProd ? "icon-blue" : "icon-red"} icon-white`}></i>
                </ListItemIcon>
                <ListItemText primary={t("masters")} style={{ marginLeft: "" }} />
                {openMasters ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            ) : ""}
            <Collapse in={openMasters} timeout="auto" unmountOnExit>
              <Divider />
              <List component="div" disablePadding>
                {hasOrganizationPermission("Organization") ||
                  hasZonePermission("Zone") ||
                  hasWardPermission("Ward") ||
                  hasShiftsPermission("Shifts") ? (
                  <ListItem
                    button
                    onClick={handleToggleOrganizationStructure}
                    style={{
                      display: hasOrganizationPermission("Organization") ? "block d-flex" : "none",
                    }}
                  >
                    <ListItemText
                      inset
                      primary={t("organizationStructure")}
                      style={{ paddingLeft: "25px" }}
                    />
                    {openOrganizationStructure ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                ) : ""}
                <Collapse in={openOrganizationStructure} timeout="auto" className="level-4" unmountOnExit>
                  {hasOrganizationPermission("Organization") && hasZonePermission("Zone") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/organization-zone" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/organization-zone"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("zones")} style={{ paddingLeft: "25px" }} onClick={handleZoneClick} />
                      {location.pathname === "/organization-zone" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasOrganizationPermission("Organization") && hasCirclePermission("Ward") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/organization-circle" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/organization-circle"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("Wards")} style={{ paddingLeft: "25px" }} onClick={handleCircleClick} />
                      {location.pathname === "/organization-circle" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasOrganizationPermission("Organization") && hasShiftsPermission("Shifts") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/shifts" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/shifts"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("shiftMaster")} style={{ paddingLeft: "25px" }} onClick={handleShiftsClick} />
                      {location.pathname === "/shifts" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasTransferStationPermission("TransferStation") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/transferStation" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/transferStation"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("transferStations")} style={{ paddingLeft: "25px" }} onClick={handleTransferStationClick} />
                      {location.pathname === "/transferStation" && <ActiveIndicator />}
                    </ListItem>
                  )}
                </Collapse>
                {hasMasterAssetsPermission("Assets") || hasContainersPermission("Containers") ? (
                  <ListItem button onClick={handleToggleAssetsMasters}>
                    <ListItemText inset primary={t("assetMaster")} style={{ paddingLeft: "25px" }} />
                    {openAssetsMasters ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                ) : ""}
                <Collapse in={openAssetsMasters} timeout="auto" unmountOnExit className="level-4">
                  {hasVehicleTypePermission("Vehicle Type") && hasMasterAssetsPermission("Assets") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/vehicle-type" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/vehicle-type"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("vehicle_type")} style={{ paddingLeft: "25px" }} onClick={handleVehicleTypeClick} />
                      {location.pathname === "/vehicle-type" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasVehicleCapacityPermission("Vehicle Capacity") && hasMasterAssetsPermission("Assets") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/vehicle-capacity" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/vehicle-capacity"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("Vehicle Capacity")} style={{ paddingLeft: "25px" }} onClick={handleVehicleCapacityClick} />
                      {location.pathname === "/vehicle-capacity" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasOwnerTypePermission("Owner Type") && hasMasterAssetsPermission("Assets") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/owner-type" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/owner-type"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("ownerType")} style={{ paddingLeft: "25px" }} onClick={handleOwnerTypeClick} />
                      {location.pathname === "/owner-type" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasVehiclePermission("Vehicles") && hasMasterAssetsPermission("Assets") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/vehicles" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/vehicles"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("vehicle")} style={{ paddingLeft: "25px" }} onClick={handleVehiclesClick} />
                      {location.pathname === "/vehicles" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasLoadingEquipmnetPermission("Loading Equipments") && hasMasterAssetsPermission("Assets") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/loading-equipment" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/loading-equipment"
                      style={{}}
                    >
                      <ListItemText inset primary={t("loadingEquipment")} style={{ paddingLeft: "25px" }} onClick={handleLoadingEuipmentClick} />
                      {location.pathname === "/loading-equipment" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasContainersPermission("Containers") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/Containers" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/Containers"
                      style={{ left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("containers")} style={{ paddingLeft: "25px" }} onClick={handleContainersClick} />
                      {location.pathname === "/Containers" && <ActiveIndicator />}
                    </ListItem>
                  )}
                </Collapse>
                {hasMasterAssetsPermission("Routes") || hasRoutesPermission("Routes") ? (
                  <ListItem button onClick={handleToggleRoutesPages}>
                    <ListItemText inset primary={t("Routes")} style={{ paddingLeft: "25px" }} />
                    {openRoutesPages ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                ) : ""}
                <Collapse in={openRoutesPages} timeout="auto" unmountOnExit className="level-4">
                  {hasCollectionPointsPermission("Route Points") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/collection-points" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/collection-points"
                      style={{ left: "1.5px", display: hasCollectionPointsPermission("Route Points") ? "block" : "none" }}
                    >
                      <ListItemText inset primary={t("Route Points")} style={{ paddingLeft: "25px" }} onClick={handleCollectionPointsClick} />
                      {location.pathname === "/collection-points" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasCollectionMasterPermission("Route Master") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/route-master" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/route-master"
                      style={{ left: "1.5px", display: hasCollectionMasterPermission("Route Master") ? "block" : "none" }}
                    >
                      <ListItemText inset primary={t("Route Master")} style={{ paddingLeft: "25px" }} onClick={handleRouteMasterClick} />
                      {location.pathname === "/route-master" && <ActiveIndicator />}
                    </ListItem>
                  )}
                  {hasCollectionPathSummaryPermission("Route Path Summary") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/route-summary-path" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/route-summary-path"
                      style={{ left: "1.5px", display: hasCollectionPathSummaryPermission("Route Path Summary") ? "block" : "none" }}
                    >
                      <ListItemText inset primary={t("Route Path Summary")} style={{ paddingLeft: "25px" }} onClick={handleRouteMasterClick} />
                      {location.pathname === "/route-summary-path" && <ActiveIndicator />}
                    </ListItem>
                  )}
                </Collapse>
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/driver-ts-map" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/driver-ts-map"
                  style={{ left: "1.5px" }}
                >
                  <ListItemText inset primary="Driver TS Map" style={{ paddingLeft: "25px" }} />
                  {location.pathname === "/driver-ts-map" && <ActiveIndicator />}
                </ListItem>
              </List>
            </Collapse>
            <ListItem
              button
              onClick={handleToggleReports}
              className={`${classes.menuItem} ${isProd ? (openReports ? "bg-ghmc" : "bg-transparent") : (openReports ? "bg-swm" : "bg-transparent")}`}
              activeClassName="active-link"
              style={{ left: "1.5px" }}
            >
              <ListItemIcon className={classes.menuItemIcon}>
                <i className={`fa-solid fa-file-lines ${isProd ? "icon-blue" : "icon-red"}`}></i>
              </ListItemIcon>
              <ListItemText primary={t("reports")} style={{ marginLeft: "" }} />
              {openReports ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </ListItem>
            <Collapse in={openReports} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {hasPrimaryCollectionReport("Primary Collection Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/primary-collection-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/primary-collection-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Primary Collection Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/primary-collection-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {hasSecondaryCollectionReport("Secondary Collection Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/secondary-collection-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/secondary-collection-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Secondary Collection Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/secondary-collection-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {hasCommercialCollectionReport("Commercial Collection Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/commercial-collection-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/commercial-collection-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Commercial Collection Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/commercial-collection-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {hasHorticultureCollectionReport("Horticulture Waste Collection & Transportation Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/horticulture-collection-transportation-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/horticulture-collection-transportation-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Horticulture Waste Collection & Transportation Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/horticulture-collection-transportation-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {hasDrainSlitCollectionReport("Drain Slit C&T Waste Collection & Transportation Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/drainslit-C&T-transportation-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/drainslit-C&T-transportation-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Drain Slit C&T Waste Collection & Transportation Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/drainslit-C&T-transportation-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {/* {hasVehicleWashingReport("Vehicle Washing Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/animalcar-C&T-transportation-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/animalcar-C&T-transportation-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Vehicle Washing Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/animalcar-C&T-transportation-report" && <ActiveIndicator />}
                  </ListItem>
                )} */}
                {hasVehicleWashingReport("Vehicle Washing Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/clearing-disinfection-bin-capsule-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/clearing-disinfection-bin-capsule-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("PCTS/FCTS/Capsule Clearing & Disinfection report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/clearing-disinfection-bin-capsule-report" && <ActiveIndicator />}
                  </ListItem>
                )}

                {hasCollectionOfSolidWasteReport("Collection of solid waste from Market Areas Report") && ( 
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/complaint-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/complaint-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Collection of solid waste from Market Areas Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/complaint-report" && <ActiveIndicator />}
                  </ListItem>
                )}


                {hasTimelyStreetSweepingReport("Timely Street sweeping B/A") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/DHW-C&T-transportation-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/DHW-C&T-transportation-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Timely Street sweeping B/A")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/DHW-C&T-transportation-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {hasInstallationOfSignageBoardsReport("Installation of Signage Boards Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/bin-clear-disinfection-transportation-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/bin-clear-disinfection-transportation-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Installation of Signage Boards on Streets/ wall painting is essential for this project, where required Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/bin-clear-disinfection-transportation-report" && <ActiveIndicator />}
                  </ListItem>
                )}
                {hasTripsAndTonnageReport("Trips and Tonnage Report") && (
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/trips-tonnage-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/trips-tonnage-report"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Trips and Tonnage Report")} style={{ paddingLeft: "15px" }} />
                    {location.pathname === "/trips-tonnage-report" && <ActiveIndicator />}
                  </ListItem>
                )}

                {hasTransactionReports("Transaction Reports") && (
                  <ListItem
                    button
                    onClick={handleToggleTransactionModuleReports}
                    className={classes.menuItem}
                    activeClassName="active-link"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText primary={t("Transaction Module")} style={{ paddingLeft: "25px" }} />
                    {openTransactionModuleReports ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </ListItem>
                )}
                <Collapse in={openTransactionModuleReports} timeout="auto" unmountOnExit className="level-4">
                  <List component="div" disablePadding>
                    {hasSecondaryDeploymentTransactionPermission("Deployment Transaction Report") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/secondary-deployment-transaction-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/secondary-deployment-transaction-report"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Deployment Transaction Report")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/secondary-deployment-transaction-report" && <ActiveIndicator />}
                      </ListItem>
                    )}
                     
                    {hasSecondaryCollectionTransactionReportPermission("Primary Collection Transaction") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/secondary-collection-transaction" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/secondary-collection-transaction"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Primary Collection Transaction")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/secondary-collection-transaction" && <ActiveIndicator />}
                      </ListItem>
                    )}
                    {hasDeployedContainerTransactionReportPermission("Deployed Container Transaction") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/deployed-container-transaction" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/deployed-container-transaction"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Deployed Container Transaction")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/deployed-container-transaction" && <ActiveIndicator />}
                      </ListItem>
                    )}
                    {hasAllTransfertationTransactionReportsPermission("Transfer Station Transaction") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/all-transferstation-transaction" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/all-transferstation-transaction"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Transfer Station Transaction")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/all-transferstation-transaction" && <ActiveIndicator />}
                      </ListItem>
                    )}


              {hasHookLoaderDeploymentTransactionPermission(
                      "Deployed Hookloader Transaction Report"
                    ) &&
                      hasTransactionReports("Transaction Reports") && (
                        <ListItem
                        onClick={() => sidebarMenuClose()}
                          button
                          className={`${classes.menuItem} ${location.pathname === "/deployed-hookloader-report"
                            ? isProd
                              ? "active-ghmc"
                              : "active-swmnew"
                            : ""
                            }`}
                          component={NavLink}
                          to="/deployed-hookloader-report"
                          style={{
                            borderRadius: "0px",
                            left: "1.5px",
                          }}
                        >
                          <ListItemText
                            inset
                            primary={t("Deployed Hookloader Transaction Report")}
                            style={{ paddingLeft: "15px" }}
                          />
                          {location.pathname ===
                            "/deployed-hookloader-report" && (
                              <ActiveIndicator />
                            )}
                        </ListItem>
                      )}


                    {/* {hasContainerHookLoaderTransactionReportsPermission("Container HookLoader Transaction") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/container-hookloader-transaction" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/container-hookloader-transaction"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Container HookLoader Transaction")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/container-hookloader-transaction" && <ActiveIndicator />}
                      </ListItem>
                    )} */}
                    {/* {hasTrafficMarshalPermission("Traffic Marshal Transaction Report") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/traffic-marshal-transaction-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/traffic-marshal-transaction-report"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Traffic Marshal Transaction")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/traffic-marshal-transaction-report" && <ActiveIndicator />}
                      </ListItem>
                    )} */}
                    {hasTeritaryDeploymentPermission("Secondary Deployment") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/tertiary-deployment-details" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/tertiary-deployment-details"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Secondary Deployment")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/tertiary-deployment-details" && <ActiveIndicator />}
                      </ListItem>
                    )}
                    {hasTeritaryTripPermission("Secondary Trip") && hasTransactionReports("Transaction Reports") && (
                      <ListItem
                        onClick={() => sidebarMenuClose()}
                        button
                        className={`${classes.menuItem} ${location.pathname === "/tertiary-trip-details" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                        component={NavLink}
                        to="/tertiary-trip-details"
                        style={{ borderRadius: "0px", left: "1.5px" }}
                      >
                        <ListItemText inset primary={t("Secondary Trip")} style={{ paddingLeft: "15px" }} />
                        {location.pathname === "/tertiary-trip-details" && <ActiveIndicator />}
                      </ListItem>
                    )}
                     {hasRoutePointTransactionPermission("Route Point Transaction Report") && hasTransactionReports("Transaction Reports") && (
                    <ListItem
                      onClick={() => sidebarMenuClose()}
                      button
                      className={`${classes.menuItem} ${location.pathname === "/route-point-transaction-report" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                      component={NavLink}
                      to="/route-point-transaction-report"
                      style={{ borderRadius: "0px", left: "1.5px" }}
                    >
                      <ListItemText inset primary={t("Route Point Transaction Report")} style={{ paddingLeft: "15px" }} />
                      {location.pathname === "/route-point-transaction-report" && <ActiveIndicator />}
                    </ListItem>
                      )}
                  </List>
                </Collapse>
              </List>
            </Collapse>
            {hasMasterCreatePermission("User Management") && (
              <ListItem
                button
                onClick={handleToggleUserManagement}
                className={`${classes.menuItem} ${isProd ? (openUserManagement ? "bg-ghmc" : "bg-transparent") : (openUserManagement ? "bg-swm" : "bg-transparent")}`}
              >
                <ListItemIcon className={classes.menuItemIcon}>
                  <i className={`fa-solid fa-user ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText inset primary={t("User Management")} style={{ paddingLeft: "0px" }} />
                {openUserManagement ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            )}
            <Collapse in={openUserManagement} timeout="auto" unmountOnExit>
              {hasRolesPermission("Roles") && hasMasterCreatePermission("User Management") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/roles" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/roles"
                  style={{ display: "flex", borderRadius: "0px" }}
                >
                  <ListItemText inset primary={t("roleCreation")} style={{ paddingLeft: "25px" }} onClick={handleRolesClick} />
                  {location.pathname === "/roles" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasUserCreationsPermission("Users") && hasMasterCreatePermission("User Management") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/users" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/users"
                  style={{ borderRadius: "0px" }}
                >
                  <ListItemText inset primary={t("userCreation")} style={{ paddingLeft: "25px" }} onClick={handleUsersClick} />
                  {location.pathname === "/users" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasActiveUserPermission("Active Users") && hasMasterCreatePermission("User Management") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/active-users" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/active-users"
                  style={{ borderRadius: "0px" }}
                >
                  <ListItemText inset primary={t("Active Users")} style={{ paddingLeft: "25px" }} onClick={handleUsersClick} />
                  {location.pathname === "/active-users" && <ActiveIndicator />}
                </ListItem>
              )}
            </Collapse>
            {hasMobileUsersPermission("Mobile Users") || hasTrafficMarshalUserPermission("Traffic Marshal") ? (
              <ListItem
                button
                onClick={handleToggleMobileUsers}
                className={`${classes.menuItem} ${isProd ? (openMobileUsers ? "bg-ghmc" : "bg-transparent") : (openMobileUsers ? "bg-swm" : "bg-transparent")}`}
              >
                <ListItemIcon className={classes.menuItemIcon}>
                  <i className={`fa-solid fa-mobile-screen-button ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText inset primary={t("Mobile Users")} style={{ paddingLeft: "0px" }} />
                {openMobileUsers ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </ListItem>
            ) : ""}
            <Collapse in={openMobileUsers} timeout="auto" unmountOnExit>
              {hasDriverAppPermission("Drivers") && hasMobileUsersPermission("Mobile Users") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/scv-drivers" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/scv-drivers"
                  style={{ borderRadius: "0px", left: "1.5px" }}
                >
                  <ListItemText inset primary={t("Drivers")} style={{ paddingLeft: "25px" }} onClick={handleScvDriverClick} />
                  {location.pathname === "/scv-drivers" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasSecondaryDeploymentChargesPermission("Deployment Incharges") && hasMobileUsersPermission("Mobile Users") && (
                <ListItem
                  onClick={() => sidebarMenuClose()}
                  button
                  className={`${classes.menuItem} ${location.pathname === "/secondary-deployment-incharges" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                  component={NavLink}
                  to="/secondary-deployment-incharges"
                  style={{ borderRadius: "0px", left: "1.5px" }}
                >
                  <ListItemText inset primary={t("Deployment Incharges")} style={{ paddingLeft: "25px" }} onClick={handleSecondaryDeploymentInchargeClick} />
                  {location.pathname === "/secondary-deployment-incharges" && <ActiveIndicator />}
                </ListItem>
              )}
              {hasTransferstationInchargesPermission("TransferStation InCharge") && hasMobileUsersPermission("Mobile Users") && (
                <>
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/transferstation-incharge" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/transferstation-incharge"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Transfer Station Incharges")} style={{ paddingLeft: "25px" }} onClick={handleTransferStationInchargeClick} />
                    {location.pathname === "/transferstation-incharge" && <ActiveIndicator />}
                  </ListItem>
                  <ListItem
                    onClick={() => sidebarMenuClose()}
                    button
                    className={`${classes.menuItem} ${location.pathname === "/route-supervisor" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                    component={NavLink}
                    to="/route-supervisor"
                    style={{ borderRadius: "0px", left: "1.5px" }}
                  >
                    <ListItemText inset primary={t("Route Supervisor")} style={{ paddingLeft: "25px" }} />
                    {location.pathname === "/route-supervisor" && <ActiveIndicator />}
                  </ListItem>
                </>
              )}
            </Collapse>
            {hasMobileAPKsPermission("Mobile APK's") && (
              <ListItem
                onClick={() => sidebarMenuClose()}
                button
                className={`${classes.menuItem} ${location.pathname === "/mobile-apk's" ? isProd ? "active-ghmc" : "active-swmnew" : ""}`}
                component={NavLink}
                to="/mobile-apk's"
                style={{ left: "1.5px" }}
              >
                <ListItemIcon className={classes.menuItemIcon}>
                  <i className={`fa-solid fa-file-arrow-down ${isProd ? "icon-blue" : "icon-red"}`}></i>
                </ListItemIcon>
                <ListItemText inset primary={t("Mobile APK's")} style={{ paddingLeft: "0px" }} />
                {location.pathname === "/mobile-apk's" && <ActiveIndicator />}
              </ListItem>
            )}
            <ListItem
              button
              component={NavLink}
              to="/"
              style={{}}
              onClick={() => {
                localStorage.clear();
                sidebarMenuClose();
              }}
            >
              <ListItemIcon>
                <i className={`fa fa-sign-out-alt ${isProd ? "icon-blue" : "icon-red"}`} style={{ marginLeft: "0px" }}></i>
              </ListItemIcon>
              <ListItem button onClick={handleLogout}>
                <ListItemText primary="Logout" />
              </ListItem>
            </ListItem>
          </List>
          {isLoading && <Loader />}
        </div>
      </div>
    </div>
  );
};

const drawerWidth = "";
const useStyles = makeStyles((theme) =>
  createStyles({
    appMenu: {
      width: "100%",
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
      color: "black",
    },
    collapseInner: {
      backgroundColor: '#fff5f5'
    },
    nestedList: {
      position: "absolute",
      top: "0",
      left: "100%",
      minWidth: "240px",
      backgroundColor: "#fff",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      zIndex: "999",
    },
  })
);

const ActiveIndicator = () => (
  <div
    style={{
      display: "inline-block",
      content: '""',
      position: "absolute",
      right: 0,
      top: "50%",
      color: "#f2f2f2",
      borderRightColor: "#f4f5fd",
      marginTop: "-15px",
    }}
  />
);

export default withTranslation()(Sidebar);